<template>
  <v-sheet>
        <div class="team-box" style="text-align: left;">
          <div class="vision-statement">
            <div style="padding-right: 2%;">
                <div class="section-title" style="font-size: 2em; margin-bottom: 4%;">Our Vision.</div>
                <p class="section-text-large">To be the centre of epidemic and health intelligence for global decision makers and prevent the next pandemic.</p>
            </div>
            <div>
                <div class="section-title" style="font-size: 2em; margin-bottom: 4%;">Our Mission.</div>
              
              <p class="section-text-small" style="width: 100%;">
                To harness the power of AI and open-source data to capture early epidemic and other health signals globally and enable early detection of epidemics, leading to prevention of global spread.<br/><br/>
                To provide real-time decision support tools including to help government and non-government stakeholders mitigate risk.
              </p>
            </div>
            </div>
            <div class="image-section">
              <div class="founder-image">

                <img src="/about/raina_office.jpeg" alt="Picture of Raina MacIntyre"/>
              </div>
              <div class="founder-box">
                <h1>Founder</h1>
                <h2>Professor Raina MacIntyre</h2><br/>
                <p>
                  Professor Raina MacIntyre (MBBS Hons 1, FRACP, FAFPHM, FAAHMS, M App Epid, PhD) is Head of the Biosecurity Program at the Kirby Institute, UNSW Australia. She is a physician and epidemiologists, recognized internationally for her research on prevention and detection of epidemic infections, with a focus on pandemics, epidemics, bioterrorism and vaccines. She has received many awards including the Sir Henry Wellcome Medal and Prize from the Association of Military Surgeons of the US for work on risk-analysis of bioterrorism events.<br/><br/>
                  She is on the editorial boards of BMJ Open and Epidemiology & Infection. She has served on committees for the US National Academies of Science, Engineering and Medicine and the WHO. She conceived and founded EPIWATCH<sup>®</sup> in 2016, driven to improve rapid detection and response after the catastrophic Ebola epidemic in 2014.<br/>
                  <br/>
                  <a class="underlined" href="https://research.unsw.edu.au/people/professor-raina-macintyre">Full biography.</a>
                </p>
              </div>
            </div>
        </div>
      </v-sheet>
</template>

<script>
// @ is an alias to /src

export default {
  name: "AboutVision",
  components: {
  },
  data: () => ({
    mobile: null,
    windowWidth: null
  }),
  created() {
    window.addEventListener("resize", this.checkScreen);
    this.checkScreen();
  },
  mounted() {
    this.checkScreen()
  },
  destroy() {
    window.removeEventListener("resize", this.checkScreen);
  },
  methods: {
    checkScreen() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth <= 1000) {
        this.mobile = true;
      } else {
        this.mobile = false;
      }

      return;
    }
  },
};
</script>

<style>
.v-btn__content {
  width: 100%;
  white-space: normal;
}
</style>